
<template>
    <div class="tab-pane position-relative" :class="'show active'" :id="`setting-${index}`" role="tabpanel" tabindex="0" ref="companyTabItems">
        <div class="d-flex justify-content-between align-items-center border-bottom py-3 sticky_company_header">
            <h5 class="text-start m-0">{{ title }}</h5>
            <button type="button" class="btn btn-dark" @click="savePageData" v-ripple>Save</button>
        </div>
        <div class="tab-items mb-3">
            <QuillEditor ref="textEditor" :toolbar="toolbarOptions" theme="snow" />
        </div>
    </div>
</template>

<script setup>
import { onMounted, ref } from "vue";
import apiClient from "@/utils/axios";
import { useHttpErrorManager } from '@/composables/useHttpErrorManager';
import { useAppHelpers } from '@/composables/useAppHelpers';

const helper = useAppHelpers();

const textEditor = ref(null);
const companyTabItems = ref(null);

const props = defineProps({
    title: String,
    index: Number,
    slug: String
});

const emits = defineEmits(['dataProcessed']);

const toolbarOptions = ref([
  ['bold', 'italic', 'underline', 'strike'],
  ['blockquote', 'code-block'],

  [{ 'list': 'ordered'}, { 'list': 'bullet' }],
  [{ 'script': 'sub'}, { 'script': 'super' }],
  [{ 'indent': '-1'}, { 'indent': '+1' }],
  [{ 'direction': 'rtl' }],

  [{ 'size': ['small', false, 'large', 'huge'] }],
  [{ 'header': [1, 2, 3, 4, 5, 6, false] }],

  [{ 'color': [] }, { 'background': [] }],
  [{ 'font': [] }],
  [{ 'align': [] }],
  ['link'],
  ['clean']
]);

const dataProcessStarted = () => {
    helper.loaderOn(companyTabItems.value);
}
const dataProcessCompleted = () => {
    helper.loaderOff(companyTabItems.value);
}

const contentProcessing = ref(false);
const getPageData = async () => {
    if (!contentProcessing.value) {
        dataProcessStarted();
        contentProcessing.value = true;
        try {
            let url = 'admin/company/fetchPage/' + props.slug;
            const response = await apiClient.get(url);
            if (response.data.page) {
                textEditor.value.setHTML(response.data.page.content);
            }

            contentProcessing.value = false;
            emits('dataProcessed');
            dataProcessCompleted();
        }
        catch (error) {
            contentProcessing.value = false;
            let errorObj = await useHttpErrorManager().handleError(error, false);
            emits('dataProcessed');
            dataProcessCompleted();
        }
    }
}

const savePageData = async () => {
    if (!contentProcessing.value) {
        dataProcessStarted();
        contentProcessing.value = true;
        try {
            let url = 'admin/company/storePage/' + props.slug;
            const response = await apiClient.post(url, {content : textEditor.value.getHTML(), title: props.title });
            
            contentProcessing.value = false;
            emits('dataProcessed');
            dataProcessCompleted();
        }
        catch (error) {
            contentProcessing.value = false;
            let errorObj = await useHttpErrorManager().handleError(error, false);
            emits('dataProcessed');
            dataProcessCompleted();
        }
    }
}

onMounted(() => {
    getPageData();
})

</script>

<style lang="scss" scoped>
.sticky_company_header {
    position: sticky;
    top: 0;
    background-color: white;
    text-align: center;
    z-index: 10;
}
</style>
